/**
 * Workspace setup wizard completion (stored in workspaces.settings JSON).
 */
export function isWorkspaceSetupComplete(settings: unknown): boolean {
  if (!settings || typeof settings !== 'object') return false;
  const s = settings as Record<string, unknown>;
  return typeof s.workspace_setup_completed_at === 'string' && s.workspace_setup_completed_at.length > 0;
}
